import { DEFAULT_MODAL_DIMENSIONS, openModal } from '../openModal/openModal';
export async function openUoUPremiumModal(_ref) {
  let {
    serviceType,
    referralInfo,
    wixCodeApi,
    appParams,
    isDayful
  } = _ref;
  const modalType = 'uou_not_bookable_modal';
  return openModal({
    appParams,
    wixCodeApi,
    modalType,
    serviceType,
    dimensions: DEFAULT_MODAL_DIMENSIONS,
    referralInfo,
    isDayful
  });
}
//# sourceMappingURL=openUoUPremiumModal.js.map